import { AssetPath } from '@gnsx/genesys.js';

import { gamesApi } from '../api/games';
import { StorageProviderType } from '../storage/interfaces';

import type { IStorageProvider } from '../storage/interfaces';
import type { GameQueryParamsValues, GameRecord } from '@/types/game';

import { GAMES_FOLDER } from '@/types/game';



export interface GameRecordDirectory extends GameRecord {
  path: string;
}

export interface ListGamesOptions {
  onlyMyGames: boolean;
  published: GameQueryParamsValues;
}

export class GamesProvider {
  static async listGames(provider: IStorageProvider, options: ListGamesOptions): Promise<GameRecordDirectory[]> {
    if (provider.providerType === StorageProviderType.FILE_SERVER) {
      const games = await provider.listFiles(AssetPath.fromString(GAMES_FOLDER));
      return games.directories.map(dir => {
        const createdAt = dir.modifiedTime ? dir.modifiedTime.toISOString() : new Date().toISOString();
        const updatedAt = dir.modifiedTime ? dir.modifiedTime.toISOString() : createdAt;
        return {
          gameId: dir.name,
          ownerId: '',
          createdAt,
          updatedAt,
          published: false,
          canModify: true,
          metadata: {
            name: dir.name,
            description: 'This is a local game',
            tags: [],
            thumbnailUrl: ''
          },
          path: dir.path,
          name: dir.name,
        };
      });
    } else {
      const games = await gamesApi.list({
        onlyMyGames: options.onlyMyGames,
        published: options.published,
      });
      return games.map(game => {
        return {
          ...game,
          name: game.metadata.name,
          path: `${GAMES_FOLDER}/${game.gameId}`,
        };
      });
    }
  }
}
